// Real calendar date ranges (not mock) for querying getUsage(). Each range is passed
// straight to the AI service's /v0/usage endpoint (dateFrom/dateTo), which is already
// scoped to the caller's own org via their JWT — no separate org-selection needed.
function toIso(date) {
  return date.toISOString();
}

export function getYearToDateRange(now = new Date()) {
  return { dateFrom: toIso(new Date(now.getFullYear(), 0, 1)), dateTo: toIso(now) };
}

export function getMonthRangeByOffset(monthsAgo, now = new Date()) {
  const monthStart = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);
  const rangeEnd = monthsAgo === 0 ? now : new Date(now.getFullYear(), now.getMonth() - monthsAgo + 1, 1);
  return { dateFrom: toIso(monthStart), dateTo: toIso(rangeEnd) };
}

export function getTrailing30DaysRange(now = new Date()) {
  const start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  return { dateFrom: toIso(start), dateTo: toIso(now) };
}

/**
 * Rolling 12-month window ending today (not calendar-year-aligned) — used for the
 * daily line chart's "Last 12 Months" view, matching MonthlyUsageChart's bar-view
 * "Last 12 Months" toggle.
 */
export function getLast12MonthsRange(now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth() - 11, now.getDate());
  return { dateFrom: toIso(start), dateTo: toIso(now) };
}

/**
 * Date ranges for each of the last N calendar months (oldest first), for the
 * monthly trend chart. monthsAgo=0 is the current (partial) month.
 */
export function getLastNMonthsRanges(count = 12, now = new Date()) {
  const ranges = [];
  for (let monthsAgo = count - 1; monthsAgo >= 0; monthsAgo--) {
    const monthStart = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1);
    ranges.push({ month: monthStart.toISOString(), ...getMonthRangeByOffset(monthsAgo, now) });
  }
  return ranges;
}

/**
 * Date ranges for Jan..current-month of the current calendar year, for the "This
 * Year" trend view. Future months (after the current one) are omitted.
 */
export function getYearMonthsRanges(now = new Date()) {
  const ranges = [];
  for (let m = 0; m <= now.getMonth(); m++) {
    const monthStart = new Date(now.getFullYear(), m, 1);
    const monthsAgo = now.getMonth() - m;
    ranges.push({ month: monthStart.toISOString(), ...getMonthRangeByOffset(monthsAgo, now) });
  }
  return ranges;
}
